export default {"src":"/_next/static/media/amazon-music.d1d183a4.svg","height":53,"width":220,"blurWidth":0,"blurHeight":0};